import React from 'react';
import styled from 'styled-components';
import { useBetting } from '../../../../../Context/BettingContext';
import { 
    Play, 
    RefreshCw, 
    Flag, 
    Info,
    ChevronRight,
    Star
} from 'lucide-react';
import { useHistory } from 'react-router-dom';

// Styled Components
const Container = styled.div`
  width: 100%;
  background: #292d2e;
  font-family: 'Montserrat', sans-serif !important;

  * {
    font-family: 'Montserrat', sans-serif !important;
  }
`;

const Header = styled.div`
  background: rgb(50, 55, 56);
  color: rgb(240, 156, 6);
  padding: 10px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
`;

const Content = styled.div`
  background: #292d2e;
  font-family: 'Montserrat', sans-serif;
`;

const Match = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px;
  border-bottom: 1px solid rgb(50, 55, 56);
  background: #292d2e;
`;

const MatchInfo = styled.div`
  flex: 1;
  font-family: 'Montserrat', sans-serif;
`;

const MatchTitle = styled.div`
  color: #ffffff;
  font-weight: bold;
  font-size: 11px;
  font-family: 'Montserrat', sans-serif;
`;

const Status = styled.span`
  color: rgb(240, 156, 6);
  font-size: 12px;
  margin-left: 14px;
  font-weight: bold;
  font-family: 'Montserrat', sans-serif;
`;

const OddsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const OddsSection = styled.div`
  display: flex;
  gap: 2px;
`;

const OddsBox = styled.div`
  background: ${props => props.blue ? '#72BBEF' : '#FFB6C1'};
  padding: 5px;
  min-width: 45px;
  text-align: center;
  border-radius: 4px;
  font-weight: bold;
  cursor: ${props => props.suspended ? 'not-allowed' : 'pointer'};
  color: ${props => props.suspended ? '#e74c3c' : 'black'} !important;
  opacity: ${props => props.suspended ? 0.7 : 1};
  transition: all 0.2s ease;

  &:hover {
    opacity: ${props => props.suspended ? 0.7 : 0.8};
  }
`;

const IconGroup = styled.div`
  display: flex;
  gap: 2px;
  margin-bottom: -5px;
  font-family: 'Montserrat', sans-serif;
`;

const Icon = styled.span`
  background: #2ecc71;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
`;

const PTE = styled.div`
  color: #ffffff;
  margin-right: 10px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
`;

const LiveDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-bottom: -5px;
  background-color: #2ecc71;
  border-radius: 50%;
  margin-right: 8px;
  animation: blink 1s ease-in-out infinite;

  @keyframes blink {
    0% { opacity: 0; }
    50% { opacity: 1; }
    100% { opacity: 0; }
  }
`;

const NOLiveDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #cccccc;
  border-radius: 50%;
  margin-right: 8px;
  margin-bottom: -5px;
`;

const NoStatus = styled.span`
  color: #cccccc;
  font-size: 10px;
  margin-left: 14px;
  font-family: normal;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;


const SportsScheduleTomorrow = () => {
  const { addBet } = useBetting();

  const matches = [
    {
      id: 101,
      team1: 'New Zealand Women',
      team2: 'Australia Women',
      status: '09:30 Tomorrow',
      isLive: false,
      pte: 'PTE5.2M',
      isSuspended: false,
      odds: {
        matched: { back: '1.85', lay: '1.95' },
        x: { back: '--', lay: '--' },
        two: { back: '2.1', lay: '2.2' }
      }
    },
    {
      id: 102,
      team1: 'South Africa',
      team2: 'Pakistan',
      status: '11:00 Tomorrow',
      isLive: false,
      pte: 'PTE15.7M',
      isSuspended: false,
      odds: {
        matched: { back: '1.65', lay: '1.75' },
        x: { back: '3.2', lay: '3.4' },
        two: { back: '2.4', lay: '2.5' }
      }
    },
    {
      id: 103,
      team1: 'England Lions',
      team2: 'Scotland',
      status: '12:15 Tomorrow',
      isLive: false,
      pte: 'PTE0',
      isSuspended: false,
      odds: {
        matched: { back: '1.45', lay: '1.55' },
        x: { back: '--', lay: '--' },
        two: { back: '2.8', lay: '2.9' }
      }
    },
    {
      id: 104,
      team1: 'Mumbai Indians',
      team2: 'Chennai Super Kings',
      status: '14:30 Tomorrow',
      isLive: false,
      pte: 'PTE45.2M',
      isSuspended: false,
      odds: {
        matched: { back: '1.95', lay: '2.05' },
        x: { back: '--', lay: '--' },
        two: { back: '1.85', lay: '1.95' }
      }
    },
    {
      id: 105,
      team1: 'Royal Challengers',
      team2: 'Kolkata Knight Riders',
      status: '15:45 Tomorrow',
      isLive: false,
      pte: 'PTE32.1M',
      isSuspended: false,
      odds: {
        matched: { back: '2.1', lay: '2.2' },
        x: { back: '--', lay: '--' },
        two: { back: '1.75', lay: '1.85' }
      }
    },
    {
      id: 106,
      team1: 'Delhi Capitals',
      team2: 'Punjab Kings',
      status: '17:00 Tomorrow',
      isLive: false,
      pte: 'PTE18.9M',
      isSuspended: false,
      odds: {
        matched: { back: '1.7', lay: '1.8' },
        x: { back: '--', lay: '--' },
        two: { back: '2.2', lay: '2.3' }
      }
    },
    {
      id: 107,
      team1: 'Sunrisers Hyderabad',
      team2: 'Gujarat Titans',
      status: '18:30 Tomorrow',
      isLive: false,
      pte: 'PTE28.5M',
      isSuspended: false,
      odds: {
        matched: { back: '1.9', lay: '2.0' },
        x: { back: '--', lay: '--' },
        two: { back: '1.9', lay: '2.0' }
      }
    },
    {
      id: 108,
      team1: 'Rajasthan Royals',
      team2: 'Lucknow Super Giants',
      status: '19:45 Tomorrow',
      isLive: false,
      pte: 'PTE22.3M',
      isSuspended: false,
      odds: {
        matched: { back: '2.05', lay: '2.15' },
        x: { back: '--', lay: '--' },
        two: { back: '1.8', lay: '1.9' }
      }
    }
  ];

  const handleOddsClick = (match, category, type, odds) => {
    if (match.isSuspended || odds === '--' || odds === 'Suspend') return;

    // Determine the selection name based on category
    let selectionName = '';
    if (category === 'matched') {
        selectionName = match.team1;  // First team for matched category
    } else if (category === 'x') {
        selectionName = 'The Draw';   // Draw for x category
    } else if (category === 'two') {
        selectionName = match.team2;  // Second team for two category
    }

    const betDetails = {
        matchId: match.id,
        matchTitle: `${match.team1} v ${match.team2}`,
        team1: match.team1,
        team2: match.team2,
        selectionName: selectionName, // Add selection name
        category,
        type,
        odds,
        isBlue: type === 'back',
        stake: '',
        liability: '0.00'
    };

    console.log('Selected Bet:', betDetails);
    addBet(betDetails);
  };
const history=useHistory();
const handleMatchClick = (match) => {
  history.push({
    pathname: `/sports/markets/${match.id}`,
    state: {
      matchData: {
        id: match.id,
        team1: match.team1,
        team2: match.team2,
        status: match.status,
        pte: match.pte,
        odds: match.odds,
        isSuspended: match.isSuspended
      }
    }
  });
};


    return (
    <Container>
      <Header>
        <div style={{ color: 'rgb(240, 156, 6)', fontSize: '18px', fontWeight: 'bold' }}>Tomorrow</div>
      </Header>
      <Content>
        {matches.map((match, index) => (
          <Match key={index}>
            <MatchInfo onClick={() => handleMatchClick(match)}>
              <TitleContainer>
                {match.isLive ? <LiveDot /> : <NOLiveDot />}
                <MatchTitle>{`${match.team1} v ${match.team2}`}</MatchTitle>
              </TitleContainer>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {match.isLive ? <Status>In-Play</Status> : <NoStatus>{match.status}</NoStatus>}
                <IconGroup>
                  <img src='/assets/images/sports/cricket.png' style={{ width: "45px", height: "15px", objectFit: 'contain' }} />
                  <img src='/assets/images/sports/livestream.png' style={{ width: "15px", height: "15px", objectFit: 'contain' }} />
                  <img src='/assets/images/sports/watch.png' style={{ width: "15px", height: "15px", objectFit: 'contain' }} />
                  <img src='/assets/images/sports/fancy.png' style={{ width: "15px", height: "15px", objectFit: 'contain' }} />
                  <img src='/assets/images/sports/book.png' style={{ width: "15px", height: "15px", objectFit: 'contain' }} />
                </IconGroup>
              </div>
            </MatchInfo>
          </Match>
        ))}
      </Content>
    </Container>
  );
};

export default SportsScheduleTomorrow;